import { useCallback, useState } from "react";

import Box from "@mui/material/Box";
import { Button } from "@covertree/ui";

import { DocumentsUploadDialog } from "./DocumentsUploadDialog";
import { PolicyDetailsContentProps } from "../../types";

export function DocumentsUpload({ policy }: PolicyDetailsContentProps) {
  const [open, setOpen] = useState<boolean>(false);
  const toggleOpen = useCallback(() => setOpen((prevState) => !prevState), []);

  return (
    <Box display="flex" justifyContent="flex-end" mb={3}>
      <Button variant="outlined" size="small" onClick={toggleOpen}>
        Upload Signed Application
      </Button>
      <DocumentsUploadDialog
        open={open}
        onClose={toggleOpen}
        policyLocator={policy.policyLocator}
      />
    </Box>
  );
}
